// extracted by mini-css-extract-plugin
export var focusAreas = "programCard-module--focusAreas--60fbf";
export var icon = "programCard-module--icon--7b147";
export var info = "programCard-module--info--e3985";
export var logo = "programCard-module--logo--606bc";
export var org = "programCard-module--org--a7c6f";
export var orgDetails = "programCard-module--orgDetails--1705f";
export var programCard = "programCard-module--programCard--90566";